import styled from "styled-components";
import { makeStyles } from "@material-ui/core";

import { theme } from "../../themes/themes";
export const ContentCoachesHome = styled.div`
    max-width: 816px;
    .react-multi-carousel-list {
        padding-top: 25px;
        padding-bottom: 20px;
    }
    .react-multi-carousel-track {
        gap: 25px;
        margin-bottom: 8px;
    }
    .coachesHome {
        border-radius: 8px;
        border: 1px solid ${({ theme }) => theme.text.disabled};
        padding: 7px 29px;
        position: relative;
        text-align: center;
        .coach-home_img {
            width: 75px;
            margin-bottom: 24px;
            height: 75px;
            margin-top: -30px;
            border-radius: 144px;
            box-shadow: 0px 4px 4px 0px ${({ theme }) => theme.shadows.strong};
            background-color: #f8f8f8;
            object-fit: contain;
        }
    }

    .coachesHomeTitle {
        color: ${({ theme }) => theme.secondaryDarkOne};
        text-align: center;
        font-size: 18px;
        font-weight: 400;
    }
    
    .coaches-home_name {
        color: ${({ theme }) => theme.secondaryDarkOne};
        text-align: center;
        font-size: 17px;
        font-weight: 400;
        margin-top: 5px;
        margin-bottom: 0;
    }

    .coaches-home_img-language {
        border-radius: 99px;
        margin: 0;
        object-fit: cover;
        width: 22px;
        height: 20px;
    }

    .coaches-home_contentIMG {
        display: flex;
        justify-content: center;
        gap: 6px;
    }

    .coach-home_date {
        color: ${({ theme }) => theme.secondaryDarkOne};
        font-size: 12px;
        font-weight: 600;
    }

    .coach-home_hour {
        color: ${({ theme }) => theme.secondaryDarkOne};
        font-size: 13px;
        font-weight: 300;
        margin-left: 5px;
    }
    
    .coach-home_content-date {
        margin-top: 2px;
        text-align: center;
        cursor: pointer;
    }
    
    .coach-home_available {
        color: ${({ theme }) => theme.button.primary};
        text-align: center;
        margin: 11px 0;
        font-size: 14px;
        font-weight: 700;
        cursor: pointer;
        text-decoration: underline;
    }

    .react-multi-carousel-item {
        max-width: 250px;
    }

    .react-multiple-carousel__arrow {
        display: none;
    }

    .coach-home_vicibility {
        position: absolute;
        top: 1%;
        right: 3%;
        svg {
            font-size: 20px;
            cursor: pointer;
        }
    }

    .coach-home_nonavailable {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 19px;
        span {
            font-size: 20px;
            font-weight: 400;
        }
    }

    .coach-home_img-default {
        max-height: 200px;
        width: 100%;
    }
`;

export const useStyles = makeStyles(() => ({
    iconCalendar: {
        color: theme.button.primary,
        width: "0.6em",
        marginBottom: "0.1em",
    },
}));